import { render, staticRenderFns } from "./ExchangeRateFieldset.yaml?vue&type=template&id=0e4d7afe&component"
import script from "./ExchangeRateFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./ExchangeRateFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports